module.exports = __webpack_public_path__ + "static/media/bg3.5a4664c6.webp";